import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shield-yes",
  "use": "shield-yes-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"shield-yes\"><defs><style>#shield-yes .cls-1{fill-rule:evenodd}</style></defs><title>正常</title><g id=\"shield-yes_app\"><g id=\"shield-yes_画板\"><path id=\"shield-yes_正常\" class=\"cls-1\" d=\"M6 0a6 6 0 1 1-6 6 6 6 0 0 1 6-6zm3.33 3.7a.44.44 0 0 0-.63 0L5.11 6.89 4 5.84c-.31-.29-.52-.47-.64-.57l-.1-.08a.45.45 0 1 0-.5.81l.35.32L4.8 7.83a.44.44 0 0 0 .6 0l3.9-3.5.06-.06a.44.44 0 0 0-.03-.57z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/shield-yes.svg
// module id = L2Nn
// module chunks = 6